import {KTIcon} from '../../../../../../_metronic/helpers'
import {franchiseInvoice} from '../../../../core/_models'
import {useListView} from '../../core/ListViewProvider'

interface IInvoiceInfo {
  invoiceCurrentUsage: franchiseInvoice | undefined
}

const InvoiceModalHeader = ({invoiceCurrentUsage}: IInvoiceInfo) => {
  const {setItemIdForUpdate} = useListView()

  const closeModal = () => {
    setItemIdForUpdate(undefined)
  }
  return (
    <div className='modal-header'>
      <div className='card-body p-5'>
        <div className='d-flex justify-content-end'>
          <div
            className='btn btn-icon btn-sm btn-active-icon-danger'
            data-kt-users-modal-action='close'
            onClick={() => closeModal()}
            style={{cursor: 'pointer'}}
          >
            <KTIcon iconName='cross' className='fs-1' />
          </div>
        </div>

        <h1 className='fw-bold mb-2'>FATURA DE SERVIÇOS</h1>

        <div className='d-flex justify-content-between align-items-start flex-wrap mb-5'>
          <div>
            <h4 className='text-muted'>{invoiceCurrentUsage?.billingEntity?.name}</h4>
          </div>

          <div className='text-end'>
            <span
              className='d-inline-flex align-items-center fw-semibold px-3 py-1 rounded'
              style={{
                fontSize: '12px',
                cursor: 'default',
                backgroundColor: `${invoiceCurrentUsage?.status.color}20`,
                color: invoiceCurrentUsage?.status.color,
                border: `1px solid ${invoiceCurrentUsage?.status.color}`,
              }}
            >
              {invoiceCurrentUsage?.referenceCode}
            </span>

            <h5 className='fw-bold'>{invoiceCurrentUsage?.status?.name}</h5>
          </div>
        </div>
      </div>
    </div>
  )
}

export {InvoiceModalHeader}
